import {
  AdjustmentsHorizontalIcon,
  Bars3BottomLeftIcon,
  BoltIcon,
  BriefcaseIcon,
  CalendarDaysIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  Cog6ToothIcon,
  HomeIcon,
  MegaphoneIcon,
  ReceiptPercentIcon,
  RectangleGroupIcon,
  ShoppingBagIcon,
  Squares2X2Icon,
  TableCellsIcon
} from '@heroicons/vue/24/outline'

import { featureState, lockedPath } from '@/helpers/entitlements'

export const HELP_URL = 'https://help.bottle.com'

function resellersSection(ctx) {
  const stateOf = ctx.featureState || (key => featureState({ attributes: { capabilities: ctx.capabilities } }, key))
  const state = stateOf('resellers')
  if (state === 'hidden') return []
  if (state === 'locked')
    return [{ name: 'Resellers', icon: BriefcaseIcon, route: lockedPath('resellers'), locked: true }]
  return [{ name: 'Resellers', icon: BriefcaseIcon, route: '/resellers' }]
}

export function ecommerceSections(ctx) {
  return [
    { name: 'Orders', icon: ReceiptPercentIcon, route: '/orders' },
    { name: 'Messages', type: 'messages', icon: ChatBubbleOvalLeftEllipsisIcon, route: '/messages' },
    { name: 'Customers', icon: RectangleGroupIcon, route: '/lists' },
    ...resellersSection(ctx),
    { name: 'Sell', icon: ShoppingBagIcon, route: '/sell' },
    { type: 'separator' },
    { name: 'Automation', icon: AdjustmentsHorizontalIcon, route: '/automation/drop/new' },
    { name: 'AI Agents', type: 'ai', icon: BoltIcon, route: '/ai/agents' },
    ...(ctx.capabilities?.includes('marketing-agent')
      ? [{ name: 'Marketing', icon: MegaphoneIcon, route: '/marketing' }]
      : []),
    ...(ctx.hideNumbers ? [] : [{ name: 'Reports', icon: TableCellsIcon, route: '/reports' }])
  ]
}

export function cateringSections(ctx) {
  const hasAi = ctx.capabilities?.includes('ai')
  return [
    { name: 'Dashboard', icon: HomeIcon, route: '/dashboard' },
    ...(hasAi ? [{ name: 'Leads', icon: Bars3BottomLeftIcon, route: '/leads' }] : []),
    { name: 'Orders', icon: ReceiptPercentIcon, route: '/orders' },
    { name: 'Messages', type: 'messages', icon: ChatBubbleOvalLeftEllipsisIcon, route: '/messages' },
    { name: 'Customers', icon: RectangleGroupIcon, route: '/lists' },
    { name: 'Sell', icon: ShoppingBagIcon, route: '/sell' },
    { type: 'separator' },
    ...(hasAi ? [{ name: 'Agent settings', icon: Cog6ToothIcon, route: '/agent-settings' }] : [])
  ]
}

// A franchise principal manages the shared catalogue across franchisees, nothing else.
export function franchiseSections() {
  return [
    { name: 'Dashboard', icon: HomeIcon, route: '/dashboard' },
    { name: 'Product library', icon: Squares2X2Icon, route: '/store/products' },
    { name: 'Product availability', icon: CalendarDaysIcon, route: '/availability' }
  ]
}
